import { createAction, props } from '@ngrx/store';

export enum CountriesActionTypes {
  CountriesListGet = '[Countries] Countries List Get',
  CountriesListGetSuccess = '[Countries] Countries List Get Success',
}

// CountriesList
export const actionCountriesListGet = createAction(
  CountriesActionTypes.CountriesListGet
);

export const actionCountriesListGetSuccess = createAction(
  CountriesActionTypes.CountriesListGetSuccess,
  props<{
    payload: {
      countriesList: object;
    };
  }>()
);
